module.exports = __webpack_public_path__ + "img/Dantam Hair 32.e8ac0673.jpg";